import { render, staticRenderFns } from "./FieldResolver.vue?vue&type=template&id=52ce629c"
import script from "./FieldResolver.vue?vue&type=script&lang=js"
export * from "./FieldResolver.vue?vue&type=script&lang=js"
import style0 from "./FieldResolver.vue?vue&type=style&index=0&id=52ce629c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports